export const skillsData = [
  "Javascript",
  "Typescript",
  "React",
  "MongoDB",
  "MySQL",
  "Git",
  "tailwind",
  "postgresql",
  "nginx",
  "materialui",
  "aws",
];
